import React from "react";

import { PreviewLayout } from "./";
import { QRProps } from "@/contexts/QREditorContext/types";
import { NextImage } from "../NextImage";
import { Button } from "@npm_leadtech/qr-ui-components";
import { useTranslation } from "react-i18next";

export default function PreviewWifi(props: QRProps<"wifi">) {
  const { t } = useTranslation("wifi");
  const { qrNetworkName } = props?.data;
  const isInitPreview = props?.initPreview;
  return (
    <PreviewLayout
      page="wifi"
      dataQA="preview-wifi-container"
      includeBrowser
      isInitPreview={isInitPreview}
    >
      <div className="qr-wifi-container">
        <NextImage
          src="/images/phone-previews/phone-wifi.png"
          width={241}
          height={512}
          alt="wifi preview"
          loading="lazy"
          className="default-preview default-preview-wifi"
        />
        <div className="qr-wifi-title">{t("preview_text")}</div>
        <div className="qr-wifi-networkName">
          {qrNetworkName ? `"${qrNetworkName}"?` : `"Central Cafe"?`}
        </div>

        <div className="qr-wifi-buttons">
          <Button
            shape="outlined"
            label={t("preview_cancel_button_label")}
            ariaLabel="No, cancel"
            dataQA="no-connect"
            onClick={() => {}}
            size="small"
          />
          <Button
            label={t("preview_connect_button_label")}
            ariaLabel="Yes, connect"
            dataQA="yes-connect"
            onClick={() => {}}
            size="small"
          />
        </div>
      </div>
    </PreviewLayout>
  );
}
